export const theme = {
  colors: {
    backgroundWhite: "#f0eeee",
    backgroundBlack: "#282727",
    black: "#322a1e",
    yellowMainColor: "#e8bf00",
    white: "#f9f9f9",
    grey: "#e1e1e1",
    yellowHover: "#d3ae00",
    disabled: "#8e8e8e",
  },

  fonts: {
    fontFamily: "Montserrat",
    secondFamily: "DMSans",
  },

  animations: {
    transition: "300ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
  shadows: {
    boxShadowAuth: "0 8px 32px 0 rgba(0, 0, 0, 0.32)",
  },
};
